import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { BuildingUpgradeItemResourcePackage } from "../resources/BuildingUpgradeItemResourcePackage";
import { HBox } from "../../../common/components/ui/HBox";
import { FixResult } from "../../../common/models/Building/upgrade/FixResult";
import { UpgradeResult } from "../../../common/models/Building/upgrade/UpgradeResult";
import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";
import { OwnerPiggyClubContainer } from "./OwnerPiggyClubContainer";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { PiggyMultiplier } from "../../../common/components/PiggyMultiplier";

export class InitialRewardComponent extends Container {
    public constructor(
        upgradeItemResources: BuildingUpgradeItemResourcePackage,
        commonResources: CommonResourcesPackage,
        upgradeOrFixResult: FixResult | UpgradeResult
    ) {
        super();
        const frame = new Sprite(upgradeItemResources.assets_views_building_upgrade_item_initial_reward_frame_png);
        this.addChild(frame);
        const headerText = new Text(`Initial reward`, new HeaderTextStyle());
        headerText.style.letterSpacing = 1.8;
        headerText.position.set(258.5, 95.5);
        this.addChild(headerText);
        const tokenText = new Text(`${StringFormatExtention.tokensFormat(upgradeOrFixResult.initialRewardInTokens ?? "0")}`, new HeaderTextStyle());
        const tokenIcon = new Sprite(upgradeItemResources.assets_views_building_upgrade_item_token_png);
        tokenIcon.width = 97;
        tokenIcon.height = 97;
        tokenIcon.position.y = -31;
        const piggyText = new Text(`+ ${Math.round(upgradeOrFixResult.piggyMultiplier * 100 - 100) ?? "0"}%`, new HeaderTextStyle);
        if (upgradeOrFixResult.piggyClubMultiplier != 0) {
            piggyText.text = `+ ${Math.round(upgradeOrFixResult.piggyMultiplier * 100 - 100) + Math.round(upgradeOrFixResult.piggyClubMultiplier * 100)}%`;
            const ownerPiggyClubContainer = new OwnerPiggyClubContainer(upgradeItemResources, upgradeOrFixResult);
            ownerPiggyClubContainer.pivot.x = ownerPiggyClubContainer.width;
            ownerPiggyClubContainer.position.set(572, 286);
            this.addChild(ownerPiggyClubContainer);
        }
        const piggyIcon = new PiggyMultiplier(commonResources);
        piggyIcon.scale.set(1.15);
        piggyIcon.pivot.y = piggyIcon.height * 0.3;
        const hBox = new HBox(3);
        hBox.addChild(tokenText, tokenIcon, piggyText, piggyIcon);
        hBox.position.set(frame.x + frame.width * 0.5 - hBox.width * 0.5, 206);
        this.addChild(hBox);
    }
}

class HeaderTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 48
        }));
    }
}
